var fluxHelper = {};

/**
 * Serialize Data
 * 
 * Transform a JavaScript object into a serialized string so it can be passed
 * into PHP and decoded as an array.
 *
 * @param {object} obj    Object.
 * @param {string} prefix Key.
 * @returns 
 */
fluxHelper.serializeData = function( obj, prefix ) {
    var str = [];
    for ( var p in obj ) {
        if ( obj.hasOwnProperty( p ) ) {
        var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p];
            str.push( typeof v === 'object' ? fluxHelper.serializeData( v, k ) : encodeURIComponent( k ) + '=' + encodeURIComponent( v ) );
        }
    }
    return str.join( '&' );
};

/**
 * Get Field Value.
 * 
 * Get the value of a field, depending on its type.
 *
 * @param {object} field Field.
 * @returns 
 */
fluxHelper.getFieldValue = function( field ) {
    var value = field.value; // @todo account for other field types here.

    return value;
};

/**
 * Do AJAX.
 * 
 * A simple native AJAX function.
 * 
 * @param {object} data        Data.
 * @param {function} onSuccess Success Function.
 * @param {function} onError   Error Function.
 */
fluxHelper.ajaxRequest = async function( data, onSuccess, onError ) {
    await new Promise((resolve, reject) => {
        var request = new XMLHttpRequest();
        
        request.open( 'POST', wc_checkout_params.ajax_url ); 
        request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );

        request.onload = function () {
            if ( this.status >= 200 && this.status < 400 ) {
                // Success.
                resolve( this.response );
            } else {
                // Error.
                if ( typeof onError === 'function' ) {
                    reject( 'error' );
                }
            }
        };

        request.onerror = function() {
            // Error.
            if ( typeof onError === 'function' ) {
                reject( 'error' );
            }
        };

        request.send( fluxHelper.serializeData( data ) );
    })
    .then(
        response => {
            onSuccess( response );
        }
    )
    .catch(
        error => {
            if ( typeof onError === 'function' ) {
                onError();
            } else {
                console.log( error );
            }
        }
    );
};

fluxHelper.ajaxRequestWoo = async function( data, onSuccess, onError ) {
    await new Promise((resolve, reject) => {
        var request = new XMLHttpRequest();

        var url = wc_checkout_params.wc_ajax_url.toString().replace( '%%endpoint%%', data.action );
        
        // @todo: we get deprecation warnings when passing false, 
        // we need to transpile the whole thing into ESNext and use async await.
        request.open( 'POST', url ); 
        request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );

        request.onload = function () {
            if ( this.status >= 200 && this.status < 400 ) {
                // Success.
                resolve( this.response );
            } else {
                // Error.
                if ( typeof onError === 'function' ) {
                    reject( 'error' );
                }
            }
        };

        request.onerror = function() {
            // Error.
            if ( typeof onError === 'function' ) {
                reject( 'error' );
            }
        };

        request.send( fluxHelper.serializeData( data ) );
    })
    .then(
        response => {
            onSuccess( response );
        }
    )
    .catch(
        error => {
            onError( error );
        }
    );
};

/**
 * Clean up the DOM instead of theme file override.
 */
fluxHelper.removeDomElements = function() {
    var loginToggle = document.querySelector( '.woocommerce-form-login-toggle' );
    var shopKeeperLogin = document.querySelector( '.shopkeeper_checkout_login' );
    
    if ( loginToggle ){
        loginToggle.remove();
    }

    if ( shopKeeperLogin ){
        shopKeeperLogin.remove();
    }

    fluxHelper.repositionNotices();
};

/**
 * Reposition Notices.
 * 
 * For some reason Woo does not always put the notices inside the wrapper, which breaks the layout. This fixes that.
 */
fluxHelper.repositionNotices = function () {
    var isModern = document.querySelectorAll( '.flux-checkout--modern' ).length;
    var formNotice = document.querySelector( 'form.woocommerce-checkout > .woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout' );
    var noticeWrapper = document.querySelector( '.woocommerce-notices-wrapper' );

    if ( isModern && formNotice ) {
        var error = formNotice.querySelector( '.woocommerce-error' );

        if ( !error ) {
            return;
        }
        var errorContainer = document.querySelector( '.woocommerce > .woocommerce-notices-wrapper' );
        errorContainer.append( error );
        formNotice.remove();
    }

    if ( isModern && noticeWrapper ) {
        jQuery( '.woocommerce-notices-wrapper' ).prependTo( '.flux-checkout__steps' );
    }
};

fluxHelper.isModernCheckout = function () {
    return document.querySelectorAll( '.flux-checkout--modern' ).length;
}

export default fluxHelper;